import type { ApolloError } from '@apollo/client'
import { GetRoleSupervisorsDocument, GetRoleSupervisorsQuery } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export type LegalEntities = NonNullable<
  GetRoleSupervisorsQuery['jobCatalog']['role']
>['supervisors']

type Return = [LegalEntities | undefined, boolean, () => void, ApolloError | undefined]

export const useRoleSupervisors = (id: string): Return => {
  const { data, loading, refetch, error } = useQuery(GetRoleSupervisorsDocument, {
    variables: { id },
  })

  const role = !loading ? data?.jobCatalog.role?.supervisors : undefined

  return [role, loading, refetch, error]
}
